import { NavLink } from "react-router-dom";
import "../static files/styles/pages.css";

const NotFound = () => {
  return (
    <main className="not-found">
      <h1>
        Bu kateqoriya üzrə məhsullar hazırda mövcud deyil. Yeni məhsullar
        tezliklə əlavə ediləcək.
      </h1>
      <NavLink to={"/"} className="home-page">
          Ana səhifə
      </NavLink>
    </main>
  );
};

export default NotFound;
